import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import Moment from 'moment';
import React, { Component } from 'react';
import DatePicker from 'react-datepicker';
import { translate, getActiveLanguage } from '@haldor/ui';
import { connect } from 'react-redux';

var DatePickerEvent = /*#__PURE__*/function (_Component) {
  _inherits(DatePickerEvent, _Component);

  var _super = _createSuper(DatePickerEvent);

  function DatePickerEvent(props) {
    var _props$values, _props$values2, _props$values3, _props$values4, _props$values5, _props$values6, _props$values7, _props$values8, _props$values9, _props$values10;

    var _this;

    _classCallCheck(this, DatePickerEvent);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "UNSAFE_componentWillReceiveProps", function (nextProps) {
      if (nextProps.values != null && _this.state.updated == false) {
        var _nextProps$values;

        _this.setState({
          dtPickerStartDate: nextProps.values.eventDate != null ? Moment.utc(nextProps.values.eventDate).local() : _this.state.dtPickerStartDate,
          Published: nextProps.values.published != null ? Moment.utc(nextProps.values.published).local() : _this.state.Published,
          dtPickerPublished: nextProps.values.published != null && ((_nextProps$values = nextProps.values) === null || _nextProps$values === void 0 ? void 0 : _nextProps$values.status) == 'POST_PUBLISHED' ? Moment.utc(nextProps.values.published).local() : _this.state.dtPickerPublished,
          dtPickerDueDate: nextProps.values.validUntil != null ? Moment.utc(nextProps.values.validUntil).local() : _this.state.dtPickerDueDate,
          timeEnd: nextProps.values.validUntil != null ? Moment.utc(nextProps.values.validUntil).local() : _this.state.timeEnd,
          updated: true
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _this.onChange();
    });

    _defineProperty(_assertThisInitialized(_this), "onStartChange", function (date) {
      var _this$state = _this.state,
          dtPickerStartDate = _this$state.dtPickerStartDate,
          timeStart = _this$state.timeStart,
          dtPickerDueDate = _this$state.dtPickerDueDate,
          timeEnd = _this$state.timeEnd;
      dtPickerStartDate = date != null ? Moment(date).set({
        hours: 23,
        minutes: 59,
        seconds: 59
      }) : null;
      timeStart = date != null ? Moment(date).set({
        hours: 23,
        minutes: 59,
        seconds: 59
      }) : null;

      if (date != null) {
        var dueDate = Moment(date).add(2, 'days');

        if (dtPickerDueDate != null && date.diff(dtPickerDueDate, 'days') > 0) {
          dtPickerDueDate = dueDate;
          timeEnd = dueDate;
        }
      }

      _this.setState({
        dtPickerDueDate: dtPickerDueDate,
        timeEnd: timeEnd,
        dtPickerStartDate: dtPickerStartDate,
        timeStart: timeStart
      }, function () {
        _this.onChange();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onEndChange", function (date) {
      var _this$state2 = _this.state,
          dtPickerDueDate = _this$state2.dtPickerDueDate,
          timeEnd = _this$state2.timeEnd,
          dtPickerPublished = _this$state2.dtPickerPublished,
          Published = _this$state2.Published;
      dtPickerDueDate = date != null ? Moment(date).set({
        hours: 23,
        minutes: 59,
        seconds: 59
      }) : null;
      timeEnd = date != null ? Moment(date).set({
        hours: 23,
        minutes: 59,
        seconds: 59
      }) : null;

      if (date != null) {
        var publishedDate = timeEnd;

        if (timeEnd.diff(dtPickerPublished, 'days') < 0) {
          dtPickerPublished = publishedDate;
          Published = publishedDate;
        }
      }

      _this.setState({
        dtPickerDueDate: dtPickerDueDate,
        timeEnd: timeEnd,
        dtPickerPublished: dtPickerPublished,
        Published: Published
      }, function () {
        _this.onChange();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onPublishedChange", function (date) {
      var _this$state3 = _this.state,
          dtPickerPublished = _this$state3.dtPickerPublished,
          Published = _this$state3.Published,
          dtPickerDueDate = _this$state3.dtPickerDueDate,
          timeEnd = _this$state3.timeEnd,
          dtPickerStartDate = _this$state3.dtPickerStartDate,
          timeStart = _this$state3.timeStart;
      dtPickerPublished = date != null ? Moment(date).set({
        hours: 0,
        minutes: 0,
        seconds: 0
      }) : null;
      Published = date != null ? Moment(date).set({
        hours: 0,
        minutes: 0,
        seconds: 0
      }) : null;

      if (date != null) {
        var dueDate = date.add(2, 'days');
        var startDate = date;

        if (dtPickerDueDate != null && date.diff(dtPickerDueDate) > 0) {
          dtPickerDueDate = dueDate;
          timeEnd = dueDate;
        }

        if (dtPickerStartDate != null && date.diff(dtPickerStartDate) > 0) {
          dtPickerStartDate = startDate;
          timeStart = startDate;
        }
      }

      _this.setState({
        dtPickerPublished: dtPickerPublished,
        dtPickerDueDate: dtPickerDueDate,
        timeEnd: timeEnd,
        timeStart: timeStart,
        dtPickerStartDate: dtPickerStartDate,
        Published: Published
      }, function () {
        _this.onChange();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onChange", function () {
      if (_this.props.onChange) {
        var start = _this.state.timeStart != null ? Moment(_this.state.timeStart).format() : null;
        var end = _this.state.timeEnd != null ? Moment(_this.state.timeEnd).format() : null;
        var published = _this.state.Published != null ? Moment(_this.state.Published).format() : null;
        var dates = {
          start: start,
          end: end,
          published: published
        };

        _this.props.onChange(dates);
      }
    });

    Moment.locale(getActiveLanguage());
    _this.state = {
      timeStart: ((_props$values = props.values) === null || _props$values === void 0 ? void 0 : _props$values.eventDate) != null ? Moment.utc(props.values.eventDate).local() : null,
      dtPickerStartDate: ((_props$values2 = props.values) === null || _props$values2 === void 0 ? void 0 : _props$values2.eventDate) != null ? Moment.utc(props.values.eventDate).local() : null,
      Published: ((_props$values3 = props.values) === null || _props$values3 === void 0 ? void 0 : _props$values3.published) != null && ((_props$values4 = props.values) === null || _props$values4 === void 0 ? void 0 : _props$values4.status) == 'POST_PUBLISHED' ? Moment.utc(props.values.published).local() : ((_props$values5 = props.values) === null || _props$values5 === void 0 ? void 0 : _props$values5.published) != null && Moment.utc(props.values.published).local() > Moment() ? Moment.utc(props.values.published).local() : Moment(),
      dtPickerPublished: ((_props$values6 = props.values) === null || _props$values6 === void 0 ? void 0 : _props$values6.published) != null && ((_props$values7 = props.values) === null || _props$values7 === void 0 ? void 0 : _props$values7.status) == 'POST_PUBLISHED' ? Moment.utc(props.values.published).local() : ((_props$values8 = props.values) === null || _props$values8 === void 0 ? void 0 : _props$values8.published) != null && Moment.utc(props.values.published).local() > Moment() ? Moment.utc(props.values.published).local() : Moment(),
      dtPickerDueDate: ((_props$values9 = props.values) === null || _props$values9 === void 0 ? void 0 : _props$values9.validUntil) != null ? Moment.utc(props.values.validUntil).local() : null,
      timeEnd: ((_props$values10 = props.values) === null || _props$values10 === void 0 ? void 0 : _props$values10.validUntil) != null ? Moment.utc(props.values.validUntil).local() : null,
      updated: false
    };
    return _this;
  }

  _createClass(DatePickerEvent, [{
    key: "render",
    value: function render() {
      var showEnd = this.props.showEnd;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "form-row-half"
      }, /*#__PURE__*/React.createElement("label", {
        htmlFor: "date-start"
      }, this.props.translate('publishing-date')), /*#__PURE__*/React.createElement(DatePicker, _extends({
        selected: this.state.dtPickerPublished,
        startDate: this.state.dtPickerPublished,
        selectsPublished: true,
        popperPlacement: "bottom-start",
        positionFixed: true,
        popperModifiers: {
          preventOverflow: {
            enabled: true
          },
          positionFixed: false
        },
        showWeekNumbers: true,
        onChange: this.onPublishedChange,
        previousMonthButtonLabel: "",
        nextMonthButtonLabel: ""
      }, this.state.dtPickerPublished))), /*#__PURE__*/React.createElement("div", {
        className: "form-row-half last"
      }, /*#__PURE__*/React.createElement("label", {
        htmlFor: "date-end"
      }, this.props.translate('valid-until')), /*#__PURE__*/React.createElement(DatePicker, _extends({
        selected: this.state.dtPickerDueDate,
        startDate: this.state.dtPickerStartDate,
        endDate: this.state.dtPickerDueDate,
        minDate: this.state.dtPickerStartDate,
        onChange: this.onEndChange,
        popperPlacement: "bottom-start",
        positionFixed: true,
        popperModifiers: {
          preventOverflow: {
            enabled: true
          },
          positionFixed: false
        },
        selectsEnd: true,
        showWeekNumbers: true,
        fixedHeight: true,
        previousMonthButtonLabel: "",
        nextMonthButtonLabel: ""
      }, this.state.dtPickerDueDate))), showEnd ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "form-row-half"
      }, /*#__PURE__*/React.createElement("label", {
        htmlFor: "date-start"
      }, this.props.translate('date-for-event'), " *"), /*#__PURE__*/React.createElement(DatePicker, _extends({
        selected: this.state.dtPickerStartDate,
        startDate: this.state.dtPickerStartDate,
        endDate: this.state.dtPickerDueDate,
        onChange: this.onStartChange,
        minDate: this.state.dtPickerPublished,
        required: showEnd,
        popperModifiers: {
          preventOverflow: {
            enabled: true
          },
          positionFixed: false
        },
        popperPlacement: "bottom-start",
        selectsStart: true,
        showWeekNumbers: true,
        fixedHeight: true,
        previousMonthButtonLabel: "",
        nextMonthButtonLabel: ""
      }, this.state.dtPickerStartDate))), /*#__PURE__*/React.createElement("div", {
        className: "form-row-half last"
      }, /*#__PURE__*/React.createElement("label", null), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "important-visible"
      }, this.props.translate('important-visible-seven-days'))))) : null);
    }
  }]);

  return DatePickerEvent;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    languages: state.Languages.languages
  };
}

export default connect(mapStateToProps)(DatePickerEvent);